export const DATA_RETENTION_ERROR_DISPLAY = 'helpdesk-data-retention-error-displayed';
export const REPORTS_FILTERED = 'helpdesk-reports-filtered';
export const TICKET_HISTORY_EXPORTED = 'helpdesk-ticket-history-exported';
export const TICKET_HISTORY_FILTERED = 'helpdesk-ticket-history-filtered';
export const TICKET_HISTORY_SELECTED = 'helpdesk-ticket-history-selected';
export const TIMEZONE_CHANGED = 'helpdesk-ticket-history-timezone-changed';
export const REPORT_STATUS_EXPORTED = 'helpdesk-report-status-exported';
export const REPORT_PERSONALIZED_BREAK_EXPORTED = 'helpdesk-report-breakstatus-exported';
export const ActiveMessageSegmentEventsConstants = {
    ACTIVE_MESSAGE_ENABLED: 'desk-businessinitiatedmessage-enabled',
    ACTIVE_MESSAGE_DISABLED: 'desk-businessinitiatedmessage-disabled',
    ACTIVE_MESSAGE_SAVE: 'desk-businessinitiatedmessage-saved',
    MESSAGE_TEMPLATE_OPENED: 'helpdesk-active-message-opened',
    MESSAGE_TEMPLATE_SHOW: 'desk-messagetemplate-show',
    MESSAGE_TEMPLATE_ON: 'desk-messagetemplate-on',
    MESSAGE_TEMPLATE_OFF: 'desk-messagetemplate-off',
    MESSAGE_TEMPLATE_SEARCH: 'desk-messagetemplate-search',
    MESSAGE_TEMPLATE_EDIT_SETTINGS: 'desk-messagetemplate-editsettings',
    MESSAGE_TEMPLATE_FILTER_RETURN_FLOW: 'desk-messagetemplate-filter-fluxoretorno',
    MESSAGE_TEMPLATE_FILTER_STATUS: 'desk-messagetemplate-filter-status',
    MESSAGE_TEMPLATE_UPDATE_INVALID_STATEID: 'desk-messagetemplate-update-invalid-stateid',
    MESSAGE_TEMPLATE_UPDATE_INVALID_STATEID_ERROR: 'desk-messagetemplate-update-invalid-stateid-error',
};
